module.exports = __webpack_public_path__ + "static/media/arrow-right-black.e3f75856.svg";